<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import simplebar from "simplebar-vue";
import { required, maxLength } from "vuelidate/lib/validators";
import axios from "axios";
import Swal from "sweetalert2";
export default {
  page: {
    title: "Add Rule",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, simplebar },
  data() {
    return {
      title: "Add Rule",
      items: [
        {
          text: "Monitoring Rules",
          href: "/rules/list",
        },
        {
          text: "Add Rule",
          active: true,
        },
      ],
      loginData: {},
      submitted: false,
      mapApp: new Map(),
      spclCharacterCheckName: false,
      spclCharacterCheckDesc: false,
      showAddApllnModal: false,
      customApplnList: [
      ],
      rule: {
        ruleId: 0,
        companyId: 0,
        ruleName: "",
        ruleDescription: "",
        lastModifiedTime: 0,
        enabledSettings: 0,
        officeHourSettings: 0,
        allowUserSettings: 0,
        isDeleted: 0,
        screenshotRule: {
          screenshotFrequency: 10,
          deletionPeriod: 180,
          blurLevel: 0,
        },
        webControlRule: {
          blockedCategory: 0,
        },
        activityRule: {
          workStartMinute: 0,
          workEndMinute: 0,
          workingDays: 0,
        },
        blacklistWhiteListUrls: [],
        appControleRules: [],
      },
      othersNew :{
        id: 0,
        exeName: "",
        displayName: "",
        category: 14,
        isChecked: false,
      },
      appControleDefaultCheckBoxes: {
        archiveTools: [
          {
            id: 0,
            exeName: "7zfm.exe",
            displayName: "7 zip",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "winrar.exe",
            displayName: "Winrar",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "bandizip.exe",
            displayName: "Bandizip",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "winzip64.exe",
            displayName: "Winzip",
            category: 1,
            isChecked: false,
          },
          {
            id: 1,
            exeName: "peazip.exe",
            displayName: "Peazip",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "nxpowerlite.exe",
            displayName: "Nx power lite desktop",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "powerarc.exe",
            displayName: "Powerarchiver",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "zipware.exe",
            displayName: "Zipware",
            category: 1,
            isChecked: false,
          },
        ],
        officeTools: [
          {
            id: 0,
            exeName: "powerpoint.exe",
            displayName: "Power Point",
            category: 2,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "winword.exe",
            displayName: "Windword",
            category: 2,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "wordpad.exe",
            displayName: "Wordpad",
            category: 2,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "excel.exe",
            displayName: "Excel",
            category: 2,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "wps1.exe",
            displayName: "Wps1",
            category: 2,
            isChecked: false,
          },
        ],
        cloudStorage: [
          {
            id: 0,
            exeName: "dropbox.exe",
            displayName: "Dropbox",
            category: 3,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "googledrivesync.exe",
            displayName: "Google",
            category: 3,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "app.exe",
            displayName: "Megabackup",
            category: 3,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "filemanager.exe",
            displayName: "Onedrive",
            category: 3,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "icloud.exe",
            displayName: "Icloud",
            category: 3,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "boxsync.exe",
            displayName: "Box sync",
            category: 3,
            isChecked: false,
          },
        ],
        emailClients: [
          {
            id: 0,
            exeName: "outlook.exe",
            displayName: "Outlook",
            category: 4,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "thunderbird.exe",
            displayName: "Thunderbird",
            category: 4,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "mailbird.exe",
            displayName: "Mailbird",
            category: 4,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "operamail.exe",
            displayName: "Opera Mail",
            category: 4,
            isChecked: false,
          },
        ],
        downloadManagers: [
          {
            id: 0,
            exeName: "idmain.exe",
            displayName: "Internet Download Manager",
            category: 5,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "flashget.exe",
            displayName: "Flashget",
            category: 5,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "websirerippercoiper.exe",
            displayName: "Website Ripper Copier",
            category: 5,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "fdm.exe",
            displayName: "Free Download Manager",
            category: 5,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "webzip.exe",
            displayName: "Webzip",
            category: 5,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "getright.exe",
            displayName: "Getright",
            category: 5,
            isChecked: false,
          },
        ],
        mediaPlayers: [
          {
            id: 0,
            exeName: "wmplayer.exe",
            displayName: "Windows Media Player",
            category: 6,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "vlc.exe",
            displayName: "Vlc Media Player",
            category: 6,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "kmplayer.exe",
            displayName: "Kmplayer",
            category: 6,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "itunes.exe",
            displayName: "Itunes",
            category: 6,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "potplayermini64.exe",
            displayName: "Potplayer",
            category: 6,
            isChecked: false,
          },
        ],
        opticalBurningTools: [
          {
            id: 0,
            exeName: "poweriso.exe",
            displayName: "Poweriso",
            category: 7,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "imgburn.exe",
            displayName: "Imgburn",
            category: 7,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "ultraiso.exe",
            displayName: "Ultraiso",
            category: 7,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "burningstudio14.exe",
            displayName: "Ashampoo Burning Studio",
            category: 7,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "starburn.exe",
            displayName: "Starburn",
            category: 7,
            isChecked: false,
          },
        ],
        proxy: [
          {
            id: 0,
            exeName: "proxyway.exe",
            displayName: "Proxyway",
            category: 8,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "lansuite.exe",
            displayName: "602lan Suite 2004",
            category: 8,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "ccproxy.exe",
            displayName: "Ccproxy",
            category: 8,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "fg764p.exe",
            displayName: "Fast And Secure Gateway To Internet Freedom",
            category: 8,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "u1704.exe",
            displayName: "Ultrasurf",
            category: 8,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "wingate.exe",
            displayName: "Wingate",
            category: 8,
            isChecked: false,
          },
        ],
        remoteManagementTools: [
          {
            id: 0,
            exeName: "teamviewer.exe",
            displayName: "Teamviewer",
            category: 9,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "anydesk.exe",
            displayName: "Anydesk",
            category: 9,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "aa_v3.exe",
            displayName: "Ammyy Admin",
            category: 9,
            isChecked: false,
          },
        ],
        torrentClient: [
          {
            id: 0,
            exeName: "qbittorrent.exe",
            displayName: "Qbittorrent",
            category: 10,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "utorrent.exe",
            displayName: "Utorrent",
            category: 10,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "azureus.exe",
            displayName: "Vuze",
            category: 10,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "bittorrent.exe",
            displayName: "Bittorrent",
            category: 10,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "deluge.exe",
            displayName: "Deluge",
            category: 10,
            isChecked: false,
          },
        ],
        videoChatApplications: [
          {
            id: 0,
            exeName: "ekiga.exe",
            displayName: "Ekiga",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "hipchat.exe",
            displayName: "Hipchat",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "skype.exe",
            displayName: "Skype",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "manycam.exe",
            displayName: "Manycam",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "mplayer.exe",
            displayName: "Universal Media Server",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "viber.exe",
            displayName: "Viber",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "webcammax.exe",
            displayName: "Webcammax",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "ocam.exe",
            displayName: "Ocam",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "hangout.exe",
            displayName: "Hangout",
            category: 11,
            isChecked: false,
          },
        ],
        webBrowser: [
          {
            id: 0,
            exeName: "chrome.exe",
            displayName: "Google Chrome",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "firefox.exe",
            displayName: "Mozila Firefox",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "iexplore.exe",
            displayName: "Internet Explorer",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "opera.exe",
            displayName: "Opera",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "ucbrowser.exe",
            displayName: "Uc Browser",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "safari.exe",
            displayName: "Safari",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "spark.exe",
            displayName: "Baidu",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "navigator.exe",
            displayName: "Netscape",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "dragon.exe",
            displayName: "Comodo Dragon",
            category: 12,
            isChecked: false,
          },
        ],
        textEditors: [
          {
            id: 0,
            exeName: "notepad.exe",
            displayName: "Notepad",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "notepad++.exe",
            displayName: "Notepad++",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "sublime_text.exe",
            displayName: "Sublime Text Editor",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "code.exe",
            displayName: "Visual Studio Code",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "textpad.exe",
            displayName: "Textpad",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "gvim.exe",
            displayName: "Vi Improved",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "atom.exe",
            displayName: "Atom",
            category: 13,
            isChecked: false,
          },
        ],
        others: [],
      },
      appControleCheckBoxes: {
        archiveTools: [
          {
            id: 0,
            exeName: "7zfm.exe",
            displayName: "7 zip",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "winrar.exe",
            displayName: "Winrar",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "bandizip.exe",
            displayName: "Bandizip",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "winzip64.exe",
            displayName: "Winzip",
            category: 1,
            isChecked: false,
          },
          {
            id: 1,
            exeName: "peazip.exe",
            displayName: "Peazip",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "nxpowerlite.exe",
            displayName: "Nx power lite desktop",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "powerarc.exe",
            displayName: "Powerarchiver",
            category: 1,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "zipware.exe",
            displayName: "Zipware",
            category: 1,
            isChecked: false,
          },
        ],
        officeTools: [
          {
            id: 0,
            exeName: "powerpoint.exe",
            displayName: "Power Point",
            category: 2,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "winword.exe",
            displayName: "Windword",
            category: 2,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "wordpad.exe",
            displayName: "Wordpad",
            category: 2,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "excel.exe",
            displayName: "Excel",
            category: 2,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "wps1.exe",
            displayName: "Wps1",
            category: 2,
            isChecked: false,
          },
        ],
        cloudStorage: [
          {
            id: 0,
            exeName: "dropbox.exe",
            displayName: "Dropbox",
            category: 3,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "googledrivesync.exe",
            displayName: "Google",
            category: 3,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "app.exe",
            displayName: "Megabackup",
            category: 3,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "filemanager.exe",
            displayName: "Onedrive",
            category: 3,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "icloud.exe",
            displayName: "Icloud",
            category: 3,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "boxsync.exe",
            displayName: "Box sync",
            category: 3,
            isChecked: false,
          },
        ],
        emailClients: [
          {
            id: 0,
            exeName: "outlook.exe",
            displayName: "Outlook",
            category: 4,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "thunderbird.exe",
            displayName: "Thunderbird",
            category: 4,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "mailbird.exe",
            displayName: "Mailbird",
            category: 4,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "operamail.exe",
            displayName: "Opera Mail",
            category: 4,
            isChecked: false,
          },
        ],
        downloadManagers: [
          {
            id: 0,
            exeName: "idmain.exe",
            displayName: "Internet Download Manager",
            category: 5,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "flashget.exe",
            displayName: "Flashget",
            category: 5,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "websirerippercoiper.exe",
            displayName: "Website Ripper Copier",
            category: 5,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "fdm.exe",
            displayName: "Free Download Manager",
            category: 5,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "webzip.exe",
            displayName: "Webzip",
            category: 5,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "getright.exe",
            displayName: "Getright",
            category: 5,
            isChecked: false,
          },
        ],
        mediaPlayers: [
          {
            id: 0,
            exeName: "wmplayer.exe",
            displayName: "Windows Media Player",
            category: 6,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "vlc.exe",
            displayName: "Vlc Media Player",
            category: 6,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "kmplayer.exe",
            displayName: "Kmplayer",
            category: 6,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "itunes.exe",
            displayName: "Itunes",
            category: 6,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "potplayermini64.exe",
            displayName: "Potplayer",
            category: 6,
            isChecked: false,
          },
        ],
        opticalBurningTools: [
          {
            id: 0,
            exeName: "poweriso.exe",
            displayName: "Poweriso",
            category: 7,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "imgburn.exe",
            displayName: "Imgburn",
            category: 7,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "ultraiso.exe",
            displayName: "Ultraiso",
            category: 7,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "burningstudio14.exe",
            displayName: "Ashampoo Burning Studio",
            category: 7,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "starburn.exe",
            displayName: "Starburn",
            category: 7,
            isChecked: false,
          },
        ],
        proxy: [
          {
            id: 0,
            exeName: "proxyway.exe",
            displayName: "Proxyway",
            category: 8,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "lansuite.exe",
            displayName: "602lan Suite 2004",
            category: 8,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "ccproxy.exe",
            displayName: "Ccproxy",
            category: 8,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "fg764p.exe",
            displayName: "Fast And Secure Gateway To Internet Freedom",
            category: 8,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "u1704.exe",
            displayName: "Ultrasurf",
            category: 8,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "wingate.exe",
            displayName: "Wingate",
            category: 8,
            isChecked: false,
          },
        ],
        remoteManagementTools: [
          {
            id: 0,
            exeName: "teamviewer.exe",
            displayName: "Teamviewer",
            category: 9,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "anydesk.exe",
            displayName: "Anydesk",
            category: 9,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "aa_v3.exe",
            displayName: "Ammyy Admin",
            category: 9,
            isChecked: false,
          },
        ],
        torrentClient: [
          {
            id: 0,
            exeName: "qbittorrent.exe",
            displayName: "Qbittorrent",
            category: 10,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "utorrent.exe",
            displayName: "Utorrent",
            category: 10,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "azureus.exe",
            displayName: "Vuze",
            category: 10,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "bittorrent.exe",
            displayName: "Bittorrent",
            category: 10,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "deluge.exe",
            displayName: "Deluge",
            category: 10,
            isChecked: false,
          },
        ],
        videoChatApplications: [
          {
            id: 0,
            exeName: "ekiga.exe",
            displayName: "Ekiga",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "hipchat.exe",
            displayName: "Hipchat",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "skype.exe",
            displayName: "Skype",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "manycam.exe",
            displayName: "Manycam",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "mplayer.exe",
            displayName: "Universal Media Server",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "viber.exe",
            displayName: "Viber",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "webcammax.exe",
            displayName: "Webcammax",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "ocam.exe",
            displayName: "Ocam",
            category: 11,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "hangout.exe",
            displayName: "Hangout",
            category: 11,
            isChecked: false,
          },
        ],
        webBrowser: [
          {
            id: 0,
            exeName: "chrome.exe",
            displayName: "Google Chrome",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "firefox.exe",
            displayName: "Mozila Firefox",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "iexplore.exe",
            displayName: "Internet Explorer",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "opera.exe",
            displayName: "Opera",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "ucbrowser.exe",
            displayName: "Uc Browser",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "safari.exe",
            displayName: "Safari",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "spark.exe",
            displayName: "Baidu",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "navigator.exe",
            displayName: "Netscape",
            category: 12,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "dragon.exe",
            displayName: "Comodo Dragon",
            category: 12,
            isChecked: false,
          },
        ],
        textEditors: [
          {
            id: 0,
            exeName: "notepad.exe",
            displayName: "Notepad",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "notepad++.exe",
            displayName: "Notepad++",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "sublime_text.exe",
            displayName: "Sublime Text Editor",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "code.exe",
            displayName: "Visual Studio Code",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "textpad.exe",
            displayName: "Textpad",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "gvim.exe",
            displayName: "Vi Improved",
            category: 13,
            isChecked: false,
          },
          {
            id: 0,
            exeName: "atom.exe",
            displayName: "Atom",
            category: 13,
            isChecked: false,
          },
        ],
        others: [],
      },
      enabled: false,
      success: true,
      selected: false,
      categoriesOptions: [
        {
          value: 1,
          text: "Archive Tools",
        },
        {
          value: 2,
          text: "Office Tools",
        },
        {
          value: 3,
          text: "Cloud Storage",
        },
        {
          value: 4,
          text: "Email Clients",
        },
        {
          value: 5,
          text: "Download Managers",
        },
        {
          value: 6,
          text: "Media Players",
        },
        {
          value: 7,
          text: "Optical Burning Tools",
        },
        {
          value: 8,
          text: "Proxy",
        },
        {
          value: 9,
          text: "Remote Management Tools",
        },
        {
          value: 10,
          text: "Torrent Client",
        },
        {
          value: 11,
          text: "Video Chat Applications",
        },
        {
          value: 12,
          text: "Web Browser",
        },
        {
          value: 13,
          text: "Text Editors",
        },
        {
          value: 14,
          text: "Others",
        },
      ],
      enabledSettingsCheckboxes: [
        {
          value: 8,
          isChecked: false,
        },
        {
          value: 4,
          isChecked: false,
        },
        {
          value: 2,
          isChecked: false,
        },
        {
          value: 1,
          isChecked: false,
        },
      ],

      officeHourSettingsCheckboxes: [
        {
          value: 8,
          isChecked: false,
        },
        {
          value: 4,
          isChecked: false,
        },
        {
          value: 2,
          isChecked: false,
        },
        {
          value: 1,
          isChecked: false,
        },
      ],

      allowUserSettingsCheckboxes: [
        {
          value: 8,
          isChecked: false,
        },
        {
          value: 4,
          isChecked: false,
        },
        {
          value: 2,
          isChecked: false,
        },
        {
          value: 1,
          isChecked: false,
        },
      ],
      
      actStartWorkingHour: 0,
      actStartWorkingMin: 0,
      actEndWorkingHour: 0,
      actEndWorkingMin: 0,
      actWorkingDays: [
        {
          text: "menuitems.rules.form.sun",
          value: 64,
          isChecked: false,
        },
        {
          text: "menuitems.rules.form.mon",
          value: 32,
          isChecked: false,
        },
        {
          text: "menuitems.rules.form.tue",
          value: 16,
          isChecked: false,
        },
        {
          text: "menuitems.rules.form.wed",
          value: 8,
          isChecked: false,
        },
        {
          text: "menuitems.rules.form.thu",
          value: 4,
          isChecked: false,
        },
        {
          text: "menuitems.rules.form.fri",
          value: 2,
          isChecked: false,
        },
        {
          text: "menuitems.rules.form.sat",
          value: 1,
          isChecked: false,
        },
      ],

      loader: false,
    };
  },
  validations: {
    rule: {
      ruleName: {
        required,
        maxLength: maxLength(50),
      },
      ruleDescription: {
        required,
        maxLength: maxLength(100),
      },
    },
  },
  methods: {
    addMore() {
      let d = {};
      d.id = 0;
      d.companyId = this.loginData.companyId;
      d.displayName = "";
      d.exeName = "";
      d.category = 14;
      d.isNew = true;
      d.isDeleted = 0;
      d.isChecked = false;

      this.customApplnList.push(d);
    },
    removeAppln(data) {
      if(data.isNew == true) {
        data.displayName = "";
        data.exeName = "";
      } else {
        data.isDeleted = 1;
      }
    },
    async getCustomApplnNames() {
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/rule/get_all_custom_appln",
          { params: { companyId: this.loginData.companyId } }
        );
        this.customApplnList = [];
        this.appControleCheckBoxes = {};
        this.appControleCheckBoxes = JSON.parse(JSON.stringify(this.appControleDefaultCheckBoxes));
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
           
            for(var i = 0;i < response.data.data.length;i++) {
              let d = {};
              d.id = response.data.data[i].id;
              d.displayName = response.data.data[i].displayName;
              d.exeName = response.data.data[i].exeName;
              d.category = response.data.data[i].category;
              d.isDeleted = response.data.data[i].isDeleted;
              d.isNew = false;
              d.isChecked = false;
              this.customApplnList.push(d);

              d = {};
              d.id = 0;
              d.displayName = response.data.data[i].displayName;
              d.exeName = response.data.data[i].exeName;
              d.category = response.data.data[i].category;
              d.isChecked = false;

              switch(d.category) {
                case 1:            
                  this.appControleCheckBoxes.archiveTools.push(d);
                  break;
                case 2:
                  this.appControleCheckBoxes.officeTools.push(d);
                  break;
                case 3:
                  this.appControleCheckBoxes.cloudStorage.push(d);
                  break;
                case 4:
                  this.appControleCheckBoxes.emailClients.push(d);
                  break;
                case 5:
                  this.appControleCheckBoxes.downloadManagers.push(d);
                  break;
                case 6:
                  this.appControleCheckBoxes.mediaPlayers.push(d);
                  break;
                case 7:
                  this.appControleCheckBoxes.opticalBurningTools.push(d);
                  break;
                case 8:
                  this.appControleCheckBoxes.proxy.push(d);
                  break;
                case 9:
                  this.appControleCheckBoxes.remoteManagementTools.push(d);
                  break;
                case 10:
                  this.appControleCheckBoxes.torrentClient.push(d);
                  break;
                case 11:
                  this.appControleCheckBoxes.videoChatApplications.push(d);
                  break;
                case 12:
                  this.appControleCheckBoxes.webBrowser.push(d);
                  break;
                case 13:
                  this.appControleCheckBoxes.textEditors.push(d);
                  break;
                case 14:
                  this.appControleCheckBoxes.others.push(d);
                  break;
                default:
                  this.appControleCheckBoxes.others.push(d);
              }
            }
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.addMore();
    },
    preProcessAddApplnData() {
      for (var i = this.customApplnList.length - 1; i >= 0; i--) {
        let d = this.mapApp.get(this.customApplnList[i].exeName);
        this.customApplnList[i].companyId = this.loginData.companyId;

        if(this.customApplnList[i].displayName) {
          this.customApplnList[i].displayName = this.customApplnList[i].displayName.trim();
        }
        if(this.customApplnList[i].exeName) {
          this.customApplnList[i].exeName = this.customApplnList[i].exeName.trim();
        }

        if(this.customApplnList[i].displayName == "") {
          const myArray = this.customApplnList[i].exeName.split(".");
          let n = myArray[0];
          this.customApplnList[i].displayName = n;
        }
        if(d) {
            this.customApplnList.splice(i, 1);
            continue;
        }
        if(this.customApplnList[i].exeName == "") {
          if(this.customApplnList[i].isNew == true)  {
            this.customApplnList.splice(i, 1);
            continue;
          } else {
            this.customApplnList[i].isDeleted = 1;
          }
        }
      }
    },
    addApplication() {
      this.preProcessAddApplnData();
      let formData = new FormData();
      formData.append("customApplication", JSON.stringify(this.customApplnList));

      axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/rule/add_custom_appln`, formData)
          .then((res) => {
            this.showAddApllnModal = false;
            if(res.data.success == "true") {
                Swal.fire({
                  title: "Saved!",
                  text: "Applcation has been saved.",
                  icon: 'success',
                });
                this.getCustomApplnNames();
              } else {
                Swal.fire(res.data);
                this.getCustomApplnNames();
              }
            return res;
          })
          .catch((err) => {
            Swal.fire("Oops! Some error occured.");
            this.getCustomApplnNames();
            return err;
          });
    },
    handleSubmit() {
      this.loader = false;
      this.submitted = true;
      this.rule.ruleName = this.rule.ruleName.trim();
      this.rule.ruleDescription = this.rule.ruleDescription.trim();
      this.spclCharacterCheckName = false;
      this.spclCharacterCheckDesc = false;

      this.$v.$touch();

      //eslint-disable-next-line
      var format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      if(format.test(this.rule.ruleName)){
        this.spclCharacterCheckName = true;
      }

      if(format.test(this.rule.ruleDescription)){
        this.spclCharacterCheckDesc = true;
      }

      this.rule.companyId = this.loginData.companyId;
      this.rule.activityRule.workStartMinute = parseInt(this.actStartWorkingHour) * 60 + parseInt(this.actStartWorkingMin);
      this.rule.activityRule.workEndMinute = parseInt(this.actEndWorkingHour) * 60 + parseInt(this.actEndWorkingMin);

      if (this.$v.$invalid ||  this.spclCharacterCheckName ||  this.spclCharacterCheckDesc || (this.officeHourSettingsCheckboxes[1].isChecked == false && (this.rule.activityRule.workStartMinute > this.rule.activityRule.workEndMinute))) {
        return;
      }

      if(this.rule.screenshotRule.screenshotFrequency == null) {
        this.rule.screenshotRule.screenshotFrequency = 0;
      }

      if(this.rule.screenshotRule.deletionPeriod == null) {
        this.rule.screenshotRule.deletionPeriod = 0;
      }

      for (var i = 0; i < this.enabledSettingsCheckboxes.length; i++) {
        if (this.enabledSettingsCheckboxes[i].isChecked == true) {
          this.rule.enabledSettings += this.enabledSettingsCheckboxes[i].value;
        }
      }
      
      for (i = 0; i < this.officeHourSettingsCheckboxes.length; i++) {
        if (this.officeHourSettingsCheckboxes[i].isChecked == true) {
          this.rule.officeHourSettings += this.officeHourSettingsCheckboxes[i].value;
        }
      }

      for (i = 0; i < this.allowUserSettingsCheckboxes.length; i++) {
        if (this.allowUserSettingsCheckboxes[i].isChecked == true) {
          this.rule.allowUserSettings += this.allowUserSettingsCheckboxes[i].value;
        }
      }

      for (i = 0; i < this.actWorkingDays.length; i++) {
        if (this.actWorkingDays[i].isChecked == true) {
          this.rule.activityRule.workingDays += this.actWorkingDays[i].value;
        }
      }

      for (i = 0; i < this.appControleCheckBoxes.archiveTools.length; i++) {
        if (this.appControleCheckBoxes.archiveTools[i].isChecked == true) {
          this.rule.appControleRules.push(
            this.appControleCheckBoxes.archiveTools[i]
          );
        }
      }
      for (i = 0; i < this.appControleCheckBoxes.officeTools.length; i++) {
        if (this.appControleCheckBoxes.officeTools[i].isChecked == true) {
          this.rule.appControleRules.push(
            this.appControleCheckBoxes.officeTools[i]
          );
        }
      }
      for (i = 0; i < this.appControleCheckBoxes.cloudStorage.length; i++) {
        if (this.appControleCheckBoxes.cloudStorage[i].isChecked == true) {
          this.rule.appControleRules.push(
            this.appControleCheckBoxes.cloudStorage[i]
          );
        }
      }
      for (i = 0; i < this.appControleCheckBoxes.emailClients.length; i++) {
        if (this.appControleCheckBoxes.emailClients[i].isChecked == true) {
          this.rule.appControleRules.push(
            this.appControleCheckBoxes.emailClients[i]
          );
        }
      }
      for (i = 0; i < this.appControleCheckBoxes.downloadManagers.length; i++) {
        if (this.appControleCheckBoxes.downloadManagers[i].isChecked == true) {
          this.rule.appControleRules.push(
            this.appControleCheckBoxes.downloadManagers[i]
          );
        }
      }
      for (i = 0; i < this.appControleCheckBoxes.mediaPlayers.length; i++) {
        if (this.appControleCheckBoxes.mediaPlayers[i].isChecked == true) {
          this.rule.appControleRules.push(
            this.appControleCheckBoxes.mediaPlayers[i]
          );
        }
      }
      for (i = 0;i < this.appControleCheckBoxes.opticalBurningTools.length;i++) {
        if (this.appControleCheckBoxes.opticalBurningTools[i].isChecked == true) {
            this.rule.appControleRules.push(
            this.appControleCheckBoxes.opticalBurningTools[i]
          );
        }
      }
      for (i = 0; i < this.appControleCheckBoxes.proxy.length; i++) {
        if (this.appControleCheckBoxes.proxy[i].isChecked == true) {
          this.rule.appControleRules.push(this.appControleCheckBoxes.proxy[i]);
        }
      }
      for (i = 0;i < this.appControleCheckBoxes.remoteManagementTools.length;i++) {
        if (this.appControleCheckBoxes.remoteManagementTools[i].isChecked == true) {
          this.rule.appControleRules.push(
            this.appControleCheckBoxes.remoteManagementTools[i]
          );
        }
      }
      for (i = 0; i < this.appControleCheckBoxes.torrentClient.length; i++) {
        if (this.appControleCheckBoxes.torrentClient[i].isChecked == true) {
          this.rule.appControleRules.push(
            this.appControleCheckBoxes.torrentClient[i]
          );
        }
      }
      for (i = 0;i < this.appControleCheckBoxes.videoChatApplications.length;i++) {
        if (this.appControleCheckBoxes.videoChatApplications[i].isChecked == true) {
          this.rule.appControleRules.push(
            this.appControleCheckBoxes.videoChatApplications[i]
          );
        }
      }
      for (i = 0; i < this.appControleCheckBoxes.webBrowser.length; i++) {
        if (this.appControleCheckBoxes.webBrowser[i].isChecked == true) {
          this.rule.appControleRules.push(
            this.appControleCheckBoxes.webBrowser[i]
          );
        }
      }
      for (i = 0; i < this.appControleCheckBoxes.textEditors.length; i++) {
        if (this.appControleCheckBoxes.textEditors[i].isChecked == true) {
          this.rule.appControleRules.push(
            this.appControleCheckBoxes.textEditors[i]
          );
        }
      }
      let formData = new FormData();
      formData.append("rule", JSON.stringify(this.rule));

      axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/rule/add`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              Swal.fire({
                title: "Added!",
                text: "Rule has been added.",
                icon: 'success',
                onClose: () => {
                  this.$router.push('/rules/list');
                }
              });
            } else {
              Vue.swal(res.data);
            }
            return res;
          })
          .catch((err) => {
            Vue.swal("Oops! Some error occured.");
            return err;
          });

      this.submitted = false;
    },
  },
  created() {
    this.loginData = JSON.parse(localStorage.getItem('user'));
    for (var i = 0; i < this.appControleDefaultCheckBoxes.archiveTools.length; i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.archiveTools[i].exeName, this.appControleDefaultCheckBoxes.archiveTools[i].displayName);
    }
    for (i = 0; i < this.appControleDefaultCheckBoxes.officeTools.length; i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.officeTools[i].exeName, this.appControleDefaultCheckBoxes.officeTools[i].displayName);
    }
    for (i = 0; i < this.appControleDefaultCheckBoxes.cloudStorage.length; i++) {
        this.mapApp.set(this.appControleDefaultCheckBoxes.cloudStorage[i].exeName, this.appControleDefaultCheckBoxes.cloudStorage[i].displayName);
    }
    for (i = 0; i < this.appControleDefaultCheckBoxes.emailClients.length; i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.emailClients[i].exeName, this.appControleDefaultCheckBoxes.emailClients[i].displayName);
    }
    for (i = 0; i < this.appControleDefaultCheckBoxes.downloadManagers.length; i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.downloadManagers[i].exeName, this.appControleDefaultCheckBoxes.downloadManagers[i].displayName);
    }
    for (i = 0; i < this.appControleDefaultCheckBoxes.mediaPlayers.length; i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.mediaPlayers[i].exeName, this.appControleDefaultCheckBoxes.mediaPlayers[i].displayName);
    }
    for (i = 0;i < this.appControleDefaultCheckBoxes.opticalBurningTools.length;i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.opticalBurningTools[i].exeName, this.appControleDefaultCheckBoxes.opticalBurningTools[i].displayName);
    }
    for (i = 0; i < this.appControleDefaultCheckBoxes.proxy.length; i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.proxy[i].exeName, this.appControleDefaultCheckBoxes.proxy[i].displayName);
    }
    for (i = 0;i < this.appControleDefaultCheckBoxes.remoteManagementTools.length;i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.remoteManagementTools[i].exeName, this.appControleDefaultCheckBoxes.remoteManagementTools[i].displayName);
    }
    for (i = 0; i < this.appControleDefaultCheckBoxes.torrentClient.length; i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.torrentClient[i].exeName, this.appControleDefaultCheckBoxes.torrentClient[i].displayName);
    }
    for (i = 0;i < this.appControleDefaultCheckBoxes.videoChatApplications.length;i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.videoChatApplications[i].exeName, this.appControleDefaultCheckBoxes.videoChatApplications[i].displayName);
    }
    for (i = 0; i < this.appControleDefaultCheckBoxes.webBrowser.length; i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.webBrowser[i].exeName, this.appControleDefaultCheckBoxes.webBrowser[i].displayName);
    }
    for (i = 0; i < this.appControleDefaultCheckBoxes.textEditors.length; i++) {
      this.mapApp.set(this.appControleDefaultCheckBoxes.textEditors[i].exeName, this.appControleDefaultCheckBoxes.textEditors[i].displayName);
    }

    this.getCustomApplnNames();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.rules.form.addRule')" />
    <b-row>
      <b-col md="4">
        <b-form-group
          class="mb-3"
          label-cols-lg="3"
          label-for="text"
        >
          <template v-slot:label>
            {{ $t('menuitems.rules.form.ruleName') }} <i class="mdi mdi-asterisk text-danger font-size-10"></i>
          </template>
        <b-form-input
          for="text"
          v-model="rule.ruleName"
          :class="{
            'is-invalid':
            (submitted && $v.rule.ruleName.$error) || (submitted && spclCharacterCheckName),
           }"
        ></b-form-input>
        <div
          v-if="submitted && !$v.rule.ruleName.required"
          class="invalid-feedback"
        >
          {{ $t('menuitems.rules.form.ruleName') }} {{ $t('menuitems.rules.form.isRequired') }}.
        </div>
         <div
          v-if="submitted && !$v.rule.ruleName.maxLength"
          class="invalid-feedback"
        >
          {{ $t('menuitems.rules.form.only50') }}
        </div>
        <div
          v-if="submitted && spclCharacterCheckName"
          class="invalid-feedback"
        >
          {{ $t('menuitems.rules.form.spclChar') }}
        </div>
        </b-form-group>
      </b-col>


      <b-col md="8">
      <b-form-group
        class="mb-3"
        label-cols-lg="2"
        label-for="text"
      >
        <template  v-slot:label>
            {{ $t('menuitems.rules.form.ruleDescription') }}<i class="mdi mdi-asterisk text-danger font-size-10"></i>
        </template>
      <b-form-input
        for="text"
        v-model="rule.ruleDescription"
        :class="{
            'is-invalid':
            (submitted && $v.rule.ruleDescription.$error) || (submitted && spclCharacterCheckDesc),
           }"
      ></b-form-input>
      <div
          v-if="submitted && !$v.rule.ruleDescription.required"
          class="invalid-feedback"
        >
          {{ $t('menuitems.rules.form.ruleDescription') }} {{ $t('menuitems.rules.form.isRequired') }}.
        </div>
      <div
          v-if="submitted && !$v.rule.ruleDescription.maxLength"
          class="invalid-feedback"
        >
          {{ $t('menuitems.rules.form.only100') }}
        </div>
      <div
          v-if="submitted && spclCharacterCheckDesc"
          class="invalid-feedback"
        >
          {{ $t('menuitems.rules.form.spclChar') }}
        </div>
      </b-form-group>
      </b-col>
    </b-row>
    <div
      v-if="submitted && enabledSettingsCheckboxes[1].isChecked && (this.rule.activityRule.workStartMinute >= this.rule.activityRule.workEndMinute)"
      class="text-danger"
    >
      {{ $t('menuitems.rules.form.amError') }}
    </div>
    <div class="checkout-tabs">
      <b-tabs
        pills
        vertical
        nav-class="p-0"
        nav-wrapper-class="col-xl-2 col-sm-3"
      >
        <b-tab active>
          <template v-slot:title>
            <i class="bx bx-screenshot d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">{{ $t('menuitems.rules.form.screenshot') }}</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body rule-card rule-card-300">
                <h4 class="card-title font-size-20">{{ $t('menuitems.rules.form.screenshot') }}</h4>

                <p class="card-title-desc">
                  {{ $t('menuitems.rules.form.ssDescription') }}
                </p>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <label class="form-check-label" for="SwitchCheckSizemd"
                        >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="enabledSettingsCheckboxes[0].isChecked"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <label class="form-check-label"
                        >{{ $t('menuitems.rules.form.onlyForOfficeHour') }}</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="officeHourSettingsCheckboxes[0].isChecked"
                        :disabled="enabledSettingsCheckboxes[0].isChecked == false"
                      />
                    </div>
                  </div>
                  <!--<div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <label class="form-check-label"
                        >Allow User to See Reports</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="allowUserSettingsCheckboxes[0].isChecked"
                        :disabled="enabledSettingsCheckboxes[0].isChecked == false"
                      />
                    </div>
                  </div>-->
                </div>
                <br />
                <form>
                  <b-row class="mb-4">
                    <b-col md="4">
                      <label for="screenshot-interval">
                        {{ $t('menuitems.rules.form.periodically') }} :
                      </label>
                    </b-col>
                    <b-col md="3">
                      <b-form-select
                        class="form-select mb-3"
                        v-model="rule.screenshotRule.screenshotFrequency"
                        :disabled="enabledSettingsCheckboxes[0].isChecked == false"
                      >
                        <b-form-select-option :value="null"
                          >{{ $t('menuitems.rules.form.select') }}</b-form-select-option
                        >
                        <b-form-select-option :value="1"
                          >1 {{ $t('menuitems.rules.form.minutes') }}</b-form-select-option
                        >
                        <b-form-select-option :value="2"
                          >2 {{ $t('menuitems.rules.form.minutes') }}</b-form-select-option
                        >
                        <b-form-select-option :value="5"
                          >5 {{ $t('menuitems.rules.form.minutes') }}</b-form-select-option
                        >
                        <b-form-select-option :value="10"
                          >10 {{ $t('menuitems.rules.form.minutes') }}</b-form-select-option
                        >
                        <b-form-select-option :value="15"
                          >15 {{ $t('menuitems.rules.form.minutes') }}</b-form-select-option
                        >
                        <b-form-select-option :value="20"
                          >20 {{ $t('menuitems.rules.form.minutes') }}</b-form-select-option
                        >
                        <b-form-select-option :value="25"
                          >25 {{ $t('menuitems.rules.form.minutes') }}</b-form-select-option
                        >
                        <b-form-select-option :value="30"
                          >30 {{ $t('menuitems.rules.form.minutes') }}</b-form-select-option
                        >
                      </b-form-select>
                    </b-col>
                  </b-row>

                  <!--<b-row class="mb-4">
                    <b-col md="4">
                      <label for="billing-email-address"
                        >Periodically delete stored screenshot after :</label
                      >
                    </b-col>
                    <b-col md="3">
                      <b-form-select
                        class="form-select mb-3"
                        v-model="rule.screenshotRule.deletionPeriod"
                        :disabled="enabledSettingsCheckboxes[0].isChecked == false"
                      >
                        <b-form-select-option :value="null"
                          >Select...</b-form-select-option
                        >
                        <b-form-select-option value="15"
                          >15 days</b-form-select-option
                        >
                        <b-form-select-option value="30"
                          >30 days</b-form-select-option
                        >
                        <b-form-select-option value="180"
                          >6 Months</b-form-select-option
                        >
                        <b-form-select-option value="365"
                          >1 Year</b-form-select-option
                        >
                      </b-form-select>
                    </b-col>
                  </b-row>-->

                  <!--<b-row class="mb-4">
                    <b-col md="4">
                      <label for="billing-email-address"
                        >Blur Level :</label
                      >
                    </b-col>
                    <b-col md="3">
                      <b-form-select
                        class="form-select mb-3"
                        v-model="rule.screenshotRule.blurLevel"
                        :disabled="enabledSettingsCheckboxes[0].isChecked == false"
                      >
                        <b-form-select-option value="0"
                          >0</b-form-select-option
                        >
                        <b-form-select-option value="1"
                          >1</b-form-select-option
                        >
                        <b-form-select-option value="2"
                          >2</b-form-select-option
                        >
                        <b-form-select-option value="3"
                          >3</b-form-select-option
                        >
                        <b-form-select-option value="4"
                          >4</b-form-select-option
                        >
                        <b-form-select-option value="5"
                          >5</b-form-select-option
                        >
                      </b-form-select>
                    </b-col>
                  </b-row>-->

                </form>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bx-desktop d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">{{ $t('menuitems.rules.form.activityTracking') }}</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body rule-card rule-card-300" >
                <h4 class="card-title font-size-20">{{ $t('menuitems.rules.form.activityTracking') }}</h4>

                <p class="card-title-desc">
                  {{ $t('menuitems.rules.form.atDescription') }}
                </p>
                 <div class="row">
                  <div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <label class="form-check-label" for="SwitchCheckSizemd"
                        >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="enabledSettingsCheckboxes[1].isChecked"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <label class="form-check-label" for="SwitchCheckSizemd"
                        >{{ $t('menuitems.rules.form.onlyForOfficeHour') }}</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="officeHourSettingsCheckboxes[1].isChecked"
                        :disabled="enabledSettingsCheckboxes[1].isChecked == false"
                      />
                    </div>
                  </div>
                  <!--<div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <label class="form-check-label" for="SwitchCheckSizemd"
                        >Allow User to See Reports</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="allowUserSettingsCheckboxes[1].isChecked"
                        :disabled="enabledSettingsCheckboxes[1].isChecked == false"
                      />
                    </div>
                  </div>-->
                </div>
                <br />
                <form>
                  <b-row class="mb-5">
                    <b-col md="3">
                      <label for="billing-email-address"
                        >{{ $t('menuitems.rules.form.trackBetween') }} :</label
                      >
                    </b-col>
                    <b-col md="2">
                      <b-form-select
                        class="form-select mb-3"
                        v-model="actStartWorkingHour"
                        :disabled="enabledSettingsCheckboxes[1].isChecked == false || officeHourSettingsCheckboxes[1].isChecked == true"
                      >
                        <b-form-select-option :value="0"
                          >00</b-form-select-option
                        >
                        <b-form-select-option value="1"
                          >01</b-form-select-option
                        >
                        <b-form-select-option value="2"
                          >02</b-form-select-option
                        >
                        <b-form-select-option value="3"
                          >03</b-form-select-option
                        >
                        <b-form-select-option value="4"
                          >04</b-form-select-option
                        >
                        <b-form-select-option value="5"
                          >05</b-form-select-option
                        >
                        <b-form-select-option value="6"
                          >06</b-form-select-option
                        >
                        <b-form-select-option value="7"
                          >07</b-form-select-option
                        >
                        <b-form-select-option value="8"
                          >08</b-form-select-option
                        >
                        <b-form-select-option value="9"
                          >09</b-form-select-option
                        >
                        <b-form-select-option value="10"
                          >10</b-form-select-option
                        >
                        <b-form-select-option value="11"
                          >11</b-form-select-option
                        >
                        <b-form-select-option value="12"
                          >12</b-form-select-option
                        >
                        <b-form-select-option value="13"
                          >13</b-form-select-option
                        >
                        <b-form-select-option value="14"
                          >14</b-form-select-option
                        >
                        <b-form-select-option value="15"
                          >15</b-form-select-option
                        >
                        <b-form-select-option value="16"
                          >16</b-form-select-option
                        >
                        <b-form-select-option value="17"
                          >17</b-form-select-option
                        >
                        <b-form-select-option value="18"
                          >18</b-form-select-option
                        >
                        <b-form-select-option value="19"
                          >19</b-form-select-option
                        >
                        <b-form-select-option value="20"
                          >20</b-form-select-option
                        >
                        <b-form-select-option value="21"
                          >21</b-form-select-option
                        >
                        <b-form-select-option value="22"
                          >22</b-form-select-option
                        >
                        <b-form-select-option value="23"
                          >23</b-form-select-option
                        >
                      </b-form-select>
                    </b-col>
                    <b-col md="2">
                      <b-form-select
                        class="form-select mb-3"
                        v-model="actStartWorkingMin"
                        :disabled="enabledSettingsCheckboxes[1].isChecked == false || officeHourSettingsCheckboxes[1].isChecked == true"
                      >
                        <b-form-select-option :value="0"
                          >00</b-form-select-option
                        >
                        <b-form-select-option value="5"
                          >05</b-form-select-option
                        >
                        <b-form-select-option value="10"
                          >10</b-form-select-option
                        >
                        <b-form-select-option value="15"
                          >15</b-form-select-option
                        >
                        <b-form-select-option value="20"
                          >20</b-form-select-option
                        >
                        <b-form-select-option value="25"
                          >25</b-form-select-option
                        >
                        <b-form-select-option value="30"
                          >30</b-form-select-option
                        >
                        <b-form-select-option value="35"
                          >35</b-form-select-option
                        >
                        <b-form-select-option value="40"
                          >40</b-form-select-option
                        >
                        <b-form-select-option value="45"
                          >45</b-form-select-option
                        >
                        <b-form-select-option value="50"
                          >50</b-form-select-option
                        >
                        <b-form-select-option value="55"
                          >55</b-form-select-option
                        >
                        <b-form-select-option value="60"
                          >60</b-form-select-option
                        >
                      </b-form-select>
                    </b-col>
                    <b-col md="1"> </b-col>
                    <b-col md="2">
                      <b-form-select
                        class="form-select mb-3"
                        v-model="actEndWorkingHour"
                        :disabled="enabledSettingsCheckboxes[1].isChecked == false || officeHourSettingsCheckboxes[1].isChecked == true"
                      >
                        <b-form-select-option :value="0"
                          >00</b-form-select-option
                        >
                        <b-form-select-option value="1"
                          >01</b-form-select-option
                        >
                        <b-form-select-option value="2"
                          >02</b-form-select-option
                        >
                        <b-form-select-option value="3"
                          >03</b-form-select-option
                        >
                        <b-form-select-option value="4"
                          >04</b-form-select-option
                        >
                        <b-form-select-option value="5"
                          >05</b-form-select-option
                        >
                        <b-form-select-option value="6"
                          >06</b-form-select-option
                        >
                        <b-form-select-option value="7"
                          >07</b-form-select-option
                        >
                        <b-form-select-option value="8"
                          >08</b-form-select-option
                        >
                        <b-form-select-option value="9"
                          >09</b-form-select-option
                        >
                        <b-form-select-option value="10"
                          >10</b-form-select-option
                        >
                        <b-form-select-option value="11"
                          >11</b-form-select-option
                        >
                        <b-form-select-option value="12"
                          >12</b-form-select-option
                        >
                        <b-form-select-option value="13"
                          >13</b-form-select-option
                        >
                        <b-form-select-option value="14"
                          >14</b-form-select-option
                        >
                        <b-form-select-option value="15"
                          >15</b-form-select-option
                        >
                        <b-form-select-option value="16"
                          >16</b-form-select-option
                        >
                        <b-form-select-option value="17"
                          >17</b-form-select-option
                        >
                        <b-form-select-option value="18"
                          >18</b-form-select-option
                        >
                        <b-form-select-option value="19"
                          >19</b-form-select-option
                        >
                        <b-form-select-option value="20"
                          >20</b-form-select-option
                        >
                        <b-form-select-option value="21"
                          >21</b-form-select-option
                        >
                        <b-form-select-option value="22"
                          >22</b-form-select-option
                        >
                        <b-form-select-option value="23"
                          >23</b-form-select-option
                        >
                      </b-form-select>
                    </b-col>
                    <b-col md="2">
                      <b-form-select
                        class="form-select mb-3"
                        v-model="actEndWorkingMin"
                        :disabled="enabledSettingsCheckboxes[1].isChecked == false || officeHourSettingsCheckboxes[1].isChecked == true"
                      >
                        <b-form-select-option :value="0"
                          >00</b-form-select-option
                        >
                        <b-form-select-option value="5"
                          >05</b-form-select-option
                        >
                        <b-form-select-option value="10"
                          >10</b-form-select-option
                        >
                        <b-form-select-option value="15"
                          >15</b-form-select-option
                        >
                        <b-form-select-option value="20"
                          >20</b-form-select-option
                        >
                        <b-form-select-option value="25"
                          >25</b-form-select-option
                        >
                        <b-form-select-option value="30"
                          >30</b-form-select-option
                        >
                        <b-form-select-option value="35"
                          >35</b-form-select-option
                        >
                        <b-form-select-option value="40"
                          >40</b-form-select-option
                        >
                        <b-form-select-option value="45"
                          >45</b-form-select-option
                        >
                        <b-form-select-option value="50"
                          >50</b-form-select-option
                        >
                        <b-form-select-option value="55"
                          >55</b-form-select-option
                        >
                        <b-form-select-option value="60"
                          >60</b-form-select-option
                        >
                      </b-form-select>
                    </b-col>
                  </b-row>

                <b-row class="mb-5">
                    <b-col md="3">
                      <label for="billing-email-address">{{ $t('menuitems.rules.form.workingDays') }} :</label>
                    </b-col>
                    <b-col
                      v-for="(item, index) in actWorkingDays"
                      :key="item.text"
                      md="1"
                    >
                      <b-form-checkbox
                        v-model="actWorkingDays[index].isChecked"
                        :disabled="enabledSettingsCheckboxes[1].isChecked == false || officeHourSettingsCheckboxes[1].isChecked == true"
                        class="mb-3"
                        checked
                        plain
                        >{{ $t(item.text) }}</b-form-checkbox
                      >
                    </b-col>
                  </b-row>
                
                </form>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bx-globe d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">{{ $t('menuitems.rules.form.browsing') }}</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body rule-card rule-card-300">
                <h4 class="card-title font-size-20">{{ $t('menuitems.rules.form.browsing') }}</h4>

                <p class="card-title-desc">
                  {{ $t('menuitems.rules.form.browsingsDescription') }}
                </p>
                 <div class="row">
                  <div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <label class="form-check-label" for="SwitchCheckSizemd"
                        >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="enabledSettingsCheckboxes[2].isChecked"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <label class="form-check-label" for="SwitchCheckSizemd"
                        >{{ $t('menuitems.rules.form.onlyForOfficeHour') }}</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="officeHourSettingsCheckboxes[2].isChecked"
                        :disabled="enabledSettingsCheckboxes[2].isChecked == false"
                      />
                    </div>
                  </div>
                  <!--<div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-3">
                      <label class="form-check-label" for="SwitchCheckSizemd"
                        >Allow User to See Reports</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="allowUserSettingsCheckboxes[2].isChecked"
                      />
                    </div>
                  </div>-->
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bx-wrench d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">{{ $t('menuitems.rules.form.appControl') }}</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body rule-card rule-card-300">
                <h4 class="card-title font-size-20">{{ $t('menuitems.rules.form.appControl') }}</h4>

                <p class="card-title-desc">
                  {{ $t('menuitems.rules.form.acDescription') }}
                </p>
                 <div class="row">
                  <div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-1">
                      <label class="form-check-label" for="SwitchCheckSizemd"
                        >{{ $t('menuitems.rules.form.enable') }} / {{ $t('menuitems.rules.form.disable') }}</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="enabledSettingsCheckboxes[3].isChecked"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-12">
                      <label class="form-check-label" for="SwitchCheckSizemd"
                        >{{ $t('menuitems.rules.form.onlyForOfficeHour') }}</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="officeHourSettingsCheckboxes[3].isChecked"
                        :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                      />
                    </div>
                  </div>
                  <!--<div class="col-md-4">
                    <div class="form-check form-switch form-switch-md mb-1">
                      <label class="form-check-label" for="SwitchCheckSizemd"
                        >Allow User to See Reports</label
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="SwitchCheckSizemd"
                        v-model="allowUserSettingsCheckboxes[3].isChecked"
                        :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                      />
                    </div>
                  </div>-->
                </div>
                <br />
                <button class="btn btn-link mb-2" @click="showAddApllnModal = true">{{ $t('menuitems.rules.form.addApplication') }}</button>
                 <b-modal size="lg" v-model="showAddApllnModal" :title="$t('menuitems.rules.form.addApplication')" centered hide-footer>
                    <form @submit.prevent="addApplication">
                     <simplebar style="max-height: 245px">
                        <div class="table-responsive">
                          <table class="table table-centered table-nowrap align-middle">
                            <thead>
                              <tr>
                                <th>{{ $t('menuitems.rules.form.displayName') }}</th>
                                <th>{{ $t('menuitems.rules.form.exeName') }}</th>
                                <th>{{ $t('menuitems.rules.form.category') }}</th>
                                <th>{{ $t('menuitems.rules.action') }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(data, index) in customApplnList" :key="index">
                                <td v-if="data.isDeleted == 0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Display Name"
                                      v-model="data.displayName"
                                    />
                                </td>
                                <td v-if="data.isDeleted == 0"><input
                                      type="text"
                                      class="form-control"
                                      placeholder="Exe Name"
                                      v-model="data.exeName"
                                    /></td>
                                <td v-if="data.isDeleted == 0"><b-form-select
                                  class="form-select"
                                  v-model="data.category"
                                  :disabled="false"
                                >
                                  <b-form-select-option v-for="category in categoriesOptions" :key="category.value" :value="category.value"
                                    >{{category.text}}</b-form-select-option
                                  >
                                </b-form-select></td>
                                <td v-if="data.isDeleted == 0"><i @click="removeAppln(data)" style="cursor: pointer;" class="text-danger fs-5 bx bx-minus-circle"></i></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                     </simplebar>
                      <div class="text-end mt-3">
                       <button type="button" @click="addMore" class="btn btn-link">{{ $t('menuitems.rules.form.addMore') }}</button>
                      </div>
                      <div class="text-end mt-3">
                        <b-button variant="light" @click="showAddApllnModal = false">{{ $t('menuitems.rules.form.close') }}</b-button>
                        <b-button type="submit" variant="success" class="ms-1"
                          >{{ $t('menuitems.rules.form.save') }}</b-button
                        >
                      </div>
                    </form>
                </b-modal>
                <simplebar style="height: calc(100vh - 500px);">
                  <div class="accordion" role="tablist">
                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.archiveTools
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Archive Tools
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="archiveTools"
                        visible
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.archiveTools"
                                :key="index"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.archiveTools[index]
                                      .isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.officeTools
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Office Tools
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="officeTools"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.officeTools"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.officeTools[index]
                                      .isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.cloudStorage
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Cloud Storage
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="cloudStorage"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.cloudStorage"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.cloudStorage[index]
                                      .isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.emailClients
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Email Clients
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="emailClients"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.emailClients"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.emailClients[index]
                                      .isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.downloadManagers
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Download Managers
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="downloadManagers"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.downloadManagers"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.downloadManagers[
                                      index
                                    ].isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.mediaPlayers
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Media Players
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="mediaPlayers"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.mediaPlayers"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.mediaPlayers[index]
                                      .isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.opticalBurningTools
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Optical Burning Tools
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="opticalBurningTools"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.opticalBurningTools"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.opticalBurningTools[index]
                                      .isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.proxy
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3"> Proxy </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse id="proxy" accordion="app-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.proxy"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.proxy[index].isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.remoteManagementTools
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Remote Management Tools
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="remoteManagementTools"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.remoteManagementTools"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.remoteManagementTools[
                                      index
                                    ].isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.torrentClient
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Torrent Client
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="torrentClient"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.torrentClient"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.torrentClient[index]
                                      .isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.videoChatApplications
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Video Chat Applications
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="videoChatApplications"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.videoChatApplications"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.videoChatApplications[
                                      index
                                    ].isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.webBrowser
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Web Browser
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="webBrowser"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.webBrowser"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.webBrowser[index]
                                      .isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.textEditors
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3">
                            Text Editors
                          </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="textEditors"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.textEditors"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.textEditors[index]
                                      .isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-3 shadow-none">
                      <a
                        v-b-toggle.others
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <span class="m-0 font-size-15 me-3"> Others </span>
                          <i class="bx bxs-down-arrow"></i>
                        </b-card-header>
                      </a>
                      <b-collapse
                        id="others"
                        accordion="app-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-row class="mb-4">
                              <b-col
                                v-for="(
                                  item, index
                                ) in appControleCheckBoxes.others"
                                :key="item.displayName"
                                md="2"
                              >
                                <b-form-checkbox
                                  v-model="
                                    appControleCheckBoxes.others[index]
                                      .isChecked
                                  "
                                  :disabled="enabledSettingsCheckboxes[3].isChecked == false"
                                  class="mb-3"
                                  checked
                                  plain
                                  >{{ item.displayName }}</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </simplebar>
              </div>
            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
      <div class="row" style="margin-top: -8px;">
        <div class="col-sm-6">
          <!--<router-link
            to="/rules/list"
            class="btn text-muted d-none d-sm-inline-block btn-link"
          >
            <i class="mdi mdi-arrow-left me-1"></i> Back to Rules
          </router-link>-->
        </div>
        <!-- end col -->
        <div class="preloader-component" v-show="loader">
              <div class="status">
                <div class="spinner-chase" style="width: 100px;height: 100px;">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
        <div class="text-end">
            
          <button
            type="button"
            @click="handleSubmit()"
            class="btn btn-success mb-2 me-2"
          >
            <i class="mdi mdi-content-save"></i> {{ $t('menuitems.rules.form.save') }}
          </button>
        </div>
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.02);
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>